// ©2024 Austin App House. All rights reserved.
import React from 'react'

// Custom pagination component for react-data-table-component
// Mirrors styling/markup used in dashboard Pagination
export const RdtPagination = ({
  currentPage,
  rowCount,
  rowsPerPage,
  onChangePage,
}) => {
  const PageComponent = ({ number }) => (
    <li><a href="#" className={`${number === currentPage ? 'current_page' : ''}`}
      onClick={(e) => {
        e.preventDefault()
        window.scrollTo(0, 0)
        return number ? onChangePage(number) : null
      }}
    >{number || '...'}</a></li>

  )

  const allPages = (counts, page) => {
    if (counts <= 5 || Number.isNaN(counts)) {
      return Array.from({ length: counts })
        // eslint-disable-next-line react/no-array-index-key
        .map((el, ind) => <PageComponent key={ind + 1} number={ind + 1} />)
    }
    if (page >= 1 && page <= 3) {
      return (
        <>
          {page > 1 ? <PageComponent number={page - 1} /> : null}
          <PageComponent number={page} />
          <PageComponent number={page + 1} />
          <PageComponent />
          <PageComponent number={counts} />
        </>
      )
    }
    return (
      <>
        <PageComponent number={1} />
        <PageComponent />
        <PageComponent number={page - 1} />
        <PageComponent number={page} />
        {(counts - page) > 1 ? <PageComponent number={page + 1} /> : null}
        {(counts - page) > 2 ? <PageComponent /> : null}
        {(counts - page) > 0 ? <PageComponent number={counts} /> : null}
      </>
    )
  }

  const countOfPages = Math.ceil(rowCount / rowsPerPage)

  return (
    <div className="paging" style={{ marginTop: '5px', display: 'flex', justifyContent: 'center' }}>
      <ul style={{ display: 'inline-flex' }}>
        <li><a href="#" className={`prev_page icon_prev ${currentPage === 1 ? 'inactive' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            window.scrollTo(0, 0)
            return currentPage > 1 ? onChangePage(currentPage - 1) : null
          }}
        >Prev</a></li>
        {allPages(countOfPages, currentPage)}
        <li><a href="#" className={`next_page icon_next ${currentPage === countOfPages ? 'inactive' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            window.scrollTo(0, 0)
            return currentPage < countOfPages ? onChangePage(currentPage + 1) : null
          }}
        >Next</a></li>
      </ul>
    </div>
  )
}

export default RdtPagination


